import i18n from 'services/base/i18n';

export default {
  ok:         () => i18n.pgettext('Components|List Issues|Filter Issues|Seen Input', 'OK'),
  checkAll:   () => i18n.pgettext('Components|List Issues|Filter Issues|Seen Input', 'Select All'),
  uncheckAll: () => i18n.pgettext('Components|List Issues|Filter Issues|Seen Input', 'Unselect All'),
};
